import { createApp } from '@app/adapters/create-app'
import AutomaticallyFollowedBanner from '@app/application/workflows/components/automatically-followed-banner.vue'

let initialized = false

const initBanner = (): void => {
  if (initialized) {
    return
  }

  const elements = document.querySelectorAll<HTMLElement>(
    '[data-behaviour="automatically-followed-banner"]'
  )

  if (elements.length) {
    initialized = true
  }

  elements.forEach((element) => {
    const data = element.dataset

    const automaticallyFollowedBannerApp = createApp(
      AutomaticallyFollowedBanner,
      {
        supportArticleUrl: data.supportArticleUrl,
      }
    )

    automaticallyFollowedBannerApp.mount(element)
  })
}

window.onDomLoad(() => {
  document.addEventListener('render_async_load', initBanner)

  initBanner()

  document.addEventListener(
    'turbolinks:visit',
    () => {
      document.removeEventListener('render_async_load', initBanner)
    },
    { once: true }
  )
})
